import React, { FC, useEffect } from "react";
import { createPortal } from "react-dom";

interface LogoutModalProps {
  close: () => void;
  t: (key: string) => string;
  onConfirmAction: () => void;
}

const LogoutModal: FC<LogoutModalProps> = ({ close, t, onConfirmAction }) => {
  // ESC press => close
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [close]);

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      onMouseDown={close} // outside click => close
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal box */}
      <div
        onMouseDown={(e) => e.stopPropagation()} // inside click => don't close
        className="relative bg-gray-50 rounded-md shadow-md w-full max-w-md px-8 py-6"
      >
        <h2 className="text-xl font-bold text-purple-700 mb-4 items-center flex justify-center">
          {t("logout_confirmation_title")}
        </h2>

        <p className="text-gray-500 text-sm mb-8 text-center leading-relaxed">
          {t("logout_confirmation_message")}
        </p>

        <div className="flex gap-3">
          <button
            onClick={close}
            className="flex-1 bg-transparent hover:bg-[#d7d7fc] text-base border-purple-600 border text-purple-600 font-semibold py-2.5 rounded-md transition"
          >
            {t("cancel")}
          </button>

          <button
            onClick={() => {
              onConfirmAction();
              close();
            }}
            className="flex-1 bg-purple-600 text-white font-semibold text-base py-2.5 rounded-md transition hover:bg-[#d7d7fc] hover:text-[#7650e3] border border-purple-600"
          >
            {t("confirm")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;
